interface IconButtonProps {
    label: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    fullWidth?: boolean;
    children?: React.ReactElement;
    color?: string;
    borderColor?: string;
    textColor?: string;
    disabled?: boolean;
}

export default ({ label, onClick, disabled, fullWidth, children, color = 'blue', borderColor, textColor }: IconButtonProps) => {
    return (
        <button
            onClick={onClick}
            type="button"
            disabled={disabled}
            className={`${fullWidth ? 'w-full' : ''} py-2 px-4 flex justify-center 
            items-center 
            ${disabled ? 'bg-gray-500' : `bg-${color}-700 hover:bg-${color}-900`}
             ${borderColor ? 'border' : ''} border-${borderColor}-700 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none rounded-md`}
        >
            {children && <span className="mr-2">{children}</span>}
            <span className={`text-${textColor}-700`}>{label}</span>
        </button>
    );
};
